"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = memoizeLast;

var _shallowEqual = _interopRequireDefault(require("../shallowEqual"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * it's possible that the calculated value is actually `undefined` or `null`, so
 * it's best to use a symbol as an initial value to denote that the value has
 * never been calculated before
 *
 * note, the original implementation of this used ES6 `Symbol()` but IE 11
 */
var neverCalculated = '__NEVER_CALCULATED__';
/**
 * `memoizeLast` is similar to reselect's `createSelector` but the difference
 * is that this doesn't take in selector functions. instead you just pass in
 * references in an array and a `calculate` function
 *
 * see the tests for examples
 */

function memoizeLast(calculate) {
  var previousInputs;
  var last = neverCalculated;

  function shouldCalculate(inputs) {
    if (last === neverCalculated) return true;
    return !(0, _shallowEqual["default"])(previousInputs, inputs);
  }

  function getOrCalculate() {
    for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
      inputs[_key] = arguments[_key];
    }

    if (!shouldCalculate(inputs)) return last;
    last = calculate.apply(void 0, inputs);
    previousInputs = inputs;
    return last;
  }

  return getOrCalculate;
}